import { jsPDF } from 'jspdf'
import { fmtMoney, fmtPct, fmtDatePDF, addRiverbendHeader, addPoolsHeaderSimple as addPoolsHeader, addFooter } from './pdfHelpers'

// =============================================
// SIMPLE INVOICE PDF
// =============================================
export function generateSimpleInvoicePDF(invoice, lines) {
  var doc = new jsPDF()
  var isPool = invoice.business_id === 'pools'

  if (isPool) { addPoolsHeader(doc) } else { addRiverbendHeader(doc) }

  var y = 42

  // INVOICE title + number
  doc.setFontSize(18)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('INVOICE', 14, y)

  // Invoice info box (right side)
  var bx = 130
  doc.setFillColor(90, 90, 90)
  doc.rect(bx, y - 7, 66, 9, 'F')
  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(255, 255, 255)
  doc.text('Invoice #' + (invoice.invoice_number || '--'), bx + 3, y - 1)

  doc.setTextColor(60, 60, 60)
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.text('Date: ' + fmtDatePDF(invoice.created_at?.split('T')[0] || new Date().toISOString().split('T')[0]), bx + 3, y + 8)
  if (invoice.due_date) doc.text('Due: ' + fmtDatePDF(invoice.due_date), bx + 3, y + 13)
  if (invoice.payment_terms) doc.text('Terms: ' + invoice.payment_terms, bx + 3, y + 18)

  y += 8

  // Bill To
  doc.setFontSize(8)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('BILL TO:', 14, y)
  y += 5
  doc.setFontSize(11)
  doc.text(invoice.client_name || 'N/A', 14, y)
  y += 5
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(60, 60, 60)
  if (invoice.site_address) { doc.text(invoice.site_address, 14, y); y += 5 }
  if (invoice.client_phone) { doc.text(invoice.client_phone, 14, y); y += 5 }
  if (invoice.client_email) { doc.text(invoice.client_email, 14, y); y += 5 }

  if (invoice.job_name) {
    y += 3
    doc.setFontSize(10)
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(60, 100, 160)
    doc.text('Project: ' + invoice.job_name, 14, y)
    y += 5
  }

  y += 6

  // Table header
  doc.setFillColor(30, 40, 60)
  doc.rect(14, y, 182, 9, 'F')
  doc.setTextColor(255, 255, 255)
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(8)
  doc.text('DESCRIPTION', 16, y + 6)
  doc.text('AMOUNT', 190, y + 6, { align: 'right' })
  y += 13

  // Lines
  doc.setTextColor(30, 30, 30)
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(9)

  lines.forEach(function(l, i) {
    if (y > 250) { doc.addPage(); y = 25 }
    if (i % 2 === 0) {
      doc.setFillColor(245, 245, 248)
      doc.rect(14, y - 4, 182, 7, 'F')
    }
    var desc = doc.splitTextToSize(l.description || '', 140)
    doc.text(desc[0], 16, y)
    doc.text(fmtMoney(l.this_amount || l.scheduled_value), 190, y, { align: 'right' })
    if (desc.length > 1) { for (var j = 1; j < desc.length; j++) { y += 5; doc.text(desc[j], 16, y) } }
    y += 7
  })

  // Totals
  y += 4
  doc.setDrawColor(180, 140, 60)
  doc.setLineWidth(0.6)
  doc.line(110, y, 196, y)
  y += 8

  doc.setFontSize(10)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(60, 60, 60)
  doc.text('Subtotal:', 120, y)
  doc.text(fmtMoney(invoice.subtotal), 190, y, { align: 'right' })
  y += 6

  if (parseFloat(invoice.retainage_pct) > 0) {
    doc.text('Retainage (' + fmtPct(invoice.retainage_pct) + '):', 120, y)
    doc.text('-' + fmtMoney(invoice.retainage_held), 190, y, { align: 'right' })
    y += 6
  }

  if (parseFloat(invoice.amount_paid) > 0) {
    doc.text('Previously Paid:', 120, y)
    doc.text('-' + fmtMoney(invoice.amount_paid), 190, y, { align: 'right' })
    y += 6
  }

  doc.setDrawColor(0, 0, 0)
  doc.setLineWidth(0.3)
  doc.line(120, y, 196, y)
  y += 6

  doc.setFontSize(14)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('BALANCE DUE:', 120, y)
  doc.text(fmtMoney(invoice.balance_due || invoice.total), 190, y, { align: 'right' })

  y += 14
  if (invoice.notes) {
    doc.setFontSize(8)
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(100, 100, 100)
    var nLines = doc.splitTextToSize(invoice.notes, 178)
    doc.text(nLines, 14, y)
  }

  // Payment info
  y += 16
  if (y > 260) { doc.addPage(); y = 25 }
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(80, 80, 80)
  doc.text('Please make payment to: ' + (isPool ? 'CP Quality Pools' : 'Pietila Group LLC'), 14, y)
  y += 5
  doc.text('Questions? Contact us at (810) 923-6229', 14, y)

  addFooter(doc, isPool ? 'CP Quality Pools | Pietila Group | (810) 923-6229' : 'Riverbend Contracting Co. | 11260 Dunham Road | Hartland, MI 48353 | 8109236229')

  return doc
}

// =============================================
// AIA G702/G703 APPLICATION FOR PAYMENT PDF
// =============================================
export function generateAIAInvoicePDF(invoice, lines) {
  var doc = new jsPDF('landscape')

  // === PAGE 1: G702 - APPLICATION AND CERTIFICATE FOR PAYMENT ===
  doc.setFontSize(14)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('APPLICATION AND CERTIFICATE FOR PAYMENT', 148, 15, { align: 'center' })

  doc.setFontSize(8)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(100, 100, 100)
  doc.text('AIA Document G702', 148, 20, { align: 'center' })

  // Left info block
  var y = 30
  doc.setFontSize(9)
  doc.setTextColor(0, 0, 0)

  var infoLeft = function(label, val) {
    doc.setFont('helvetica', 'bold')
    doc.text(label, 14, y)
    doc.setFont('helvetica', 'normal')
    doc.text(String(val || ''), 55, y)
    y += 5
  }

  infoLeft('TO OWNER:', invoice.client_name || '')
  infoLeft('', invoice.site_address || '')
  y += 2
  infoLeft('FROM CONTRACTOR:', 'Riverbend Contracting Co.')
  infoLeft('', '11260 Dunham Road, Hartland, MI 48353')
  y += 2
  infoLeft('PROJECT:', invoice.job_name || '')

  // Right info block
  var ry = 30
  var infoRight = function(label, val) {
    doc.setFont('helvetica', 'bold')
    doc.text(label, 170, ry)
    doc.setFont('helvetica', 'normal')
    doc.text(String(val || ''), 220, ry)
    ry += 5
  }

  infoRight('APPLICATION NO:', String(invoice.draw_number || 1))
  infoRight('PERIOD TO:', fmtDatePDF(invoice.due_date || new Date().toISOString().split('T')[0]))
  infoRight('CONTRACT DATE:', fmtDatePDF(invoice.created_at?.split('T')[0]))
  infoRight('INVOICE #:', invoice.invoice_number || '')
  infoRight('CONTRACT FOR:', invoice.job_name || 'Land Clearing')

  y = Math.max(y, ry) + 8

  // Summary table
  doc.setDrawColor(0, 0, 0)
  doc.setLineWidth(0.3)

  var totalScheduled = lines.reduce(function(s, l) { return s + (parseFloat(l.scheduled_value) || 0) }, 0)
  var totalPrev = lines.reduce(function(s, l) { return s + (parseFloat(l.prev_amount) || 0) }, 0)
  var totalThis = lines.reduce(function(s, l) { return s + (parseFloat(l.this_amount) || 0) }, 0)
  var totalCompleted = totalPrev + totalThis
  var retainagePct = parseFloat(invoice.retainage_pct) || 0
  var retainageTotal = totalCompleted * (retainagePct / 100)
  var prevRetainage = parseFloat(invoice.prev_retainage_held) || 0
  var currentDue = totalThis - (retainageTotal - prevRetainage)

  var summaryData = [
    ['1. ORIGINAL CONTRACT SUM', fmtMoney(totalScheduled)],
    ['2. NET CHANGE BY CHANGE ORDERS', fmtMoney(0)],
    ['3. CONTRACT SUM TO DATE (1 + 2)', fmtMoney(totalScheduled)],
    ['4. TOTAL COMPLETED & STORED TO DATE', fmtMoney(totalCompleted)],
    ['5. RETAINAGE (' + fmtPct(retainagePct) + ' of Line 4)', fmtMoney(retainageTotal)],
    ['6. TOTAL EARNED LESS RETAINAGE (4 - 5)', fmtMoney(totalCompleted - retainageTotal)],
    ['7. LESS PREVIOUS CERTIFICATES FOR PAYMENT', fmtMoney(totalPrev - prevRetainage)],
    ['8. CURRENT PAYMENT DUE', fmtMoney(currentDue)],
    ['9. BALANCE TO FINISH INCLUDING RETAINAGE (3 - 4)', fmtMoney(totalScheduled - totalCompleted)]
  ]

  doc.setFontSize(9)
  summaryData.forEach(function(row) {
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(0, 0, 0)
    doc.text(row[0], 14, y + 4)
    doc.setFont('helvetica', 'bold')
    doc.text(row[1], 160, y + 4, { align: 'right' })
    doc.line(14, y + 6, 165, y + 6)
    y += 8
  })

  // Signature lines
  y += 10
  if (y > 170) { y = 170 }
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(8)
  doc.setTextColor(0, 0, 0)

  doc.text('CONTRACTOR:', 14, y)
  doc.line(42, y + 0.5, 120, y + 0.5)
  doc.text('Date:', 125, y)
  doc.line(138, y + 0.5, 180, y + 0.5)

  y += 12
  doc.text('OWNER:', 14, y)
  doc.line(32, y + 0.5, 120, y + 0.5)
  doc.text('Date:', 125, y)
  doc.line(138, y + 0.5, 180, y + 0.5)

  // === PAGE 2: G703 - CONTINUATION SHEET ===
  doc.addPage('landscape')

  doc.setFontSize(14)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('CONTINUATION SHEET', 148, 15, { align: 'center' })

  doc.setFontSize(8)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(100, 100, 100)
  doc.text('AIA Document G703 - Application #' + (invoice.draw_number || 1), 148, 20, { align: 'center' })

  // Table header
  y = 28
  var cols = [14, 24, 90, 130, 155, 180, 205, 230, 262]
  var headers = ['#', 'DESCRIPTION OF WORK', 'SCHEDULED\nVALUE', 'PREVIOUS\nAPPLICATIONS', 'THIS PERIOD', 'TOTAL\nCOMPLETED', '%', 'BALANCE\nTO FINISH', 'RETAINAGE']

  doc.setFillColor(30, 40, 60)
  doc.rect(14, y - 2, 270, 12, 'F')
  doc.setTextColor(255, 255, 255)
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(6.5)

  headers.forEach(function(h, i) {
    var x = cols[i] + 2
    if (i === 0) x = cols[i] + 1
    var hLines = h.split('\n')
    hLines.forEach(function(hl, hi) {
      doc.text(hl, x, y + 3 + (hi * 3.5))
    })
  })

  y += 14

  // Data rows
  doc.setTextColor(30, 30, 30)
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(7)

  lines.forEach(function(l, idx) {
    if (y > 185) { doc.addPage('landscape'); y = 20 }

    if (idx % 2 === 0) {
      doc.setFillColor(245, 245, 248)
      doc.rect(14, y - 3, 270, 8, 'F')
    }

    var sv = parseFloat(l.scheduled_value) || 0
    var pa = parseFloat(l.prev_amount) || 0
    var ta = parseFloat(l.this_amount) || 0
    var tc = pa + ta
    var pct = sv > 0 ? (tc / sv * 100) : 0
    var bal = sv - tc
    var ret = tc * (retainagePct / 100)

    doc.text(String(idx + 1), cols[0] + 2, y)
    var desc = doc.splitTextToSize(l.description || '', 62)
    doc.text(desc[0], cols[1] + 2, y)
    doc.text(fmtMoney(sv), cols[3] - 2, y, { align: 'right' })
    doc.text(fmtMoney(pa), cols[4] - 2, y, { align: 'right' })
    doc.text(fmtMoney(ta), cols[5] - 2, y, { align: 'right' })
    doc.text(fmtMoney(tc), cols[6] - 2, y, { align: 'right' })
    doc.text(fmtPct(pct), cols[6] + 2, y)
    doc.text(fmtMoney(bal), cols[8] - 2, y, { align: 'right' })
    doc.text(fmtMoney(ret), cols[8] + 24, y, { align: 'right' })

    // Row border
    doc.setDrawColor(200, 200, 200)
    doc.setLineWidth(0.1)
    doc.line(14, y + 3, 284, y + 3)

    y += 8
  })

  // Totals row
  y += 2
  doc.setDrawColor(0, 0, 0)
  doc.setLineWidth(0.4)
  doc.line(14, y - 2, 284, y - 2)
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(7.5)
  doc.text('TOTALS', cols[1] + 2, y + 2)
  doc.text(fmtMoney(totalScheduled), cols[3] - 2, y + 2, { align: 'right' })
  doc.text(fmtMoney(totalPrev), cols[4] - 2, y + 2, { align: 'right' })
  doc.text(fmtMoney(totalThis), cols[5] - 2, y + 2, { align: 'right' })
  doc.text(fmtMoney(totalCompleted), cols[6] - 2, y + 2, { align: 'right' })
  var overallPct = totalScheduled > 0 ? (totalCompleted / totalScheduled * 100) : 0
  doc.text(fmtPct(overallPct), cols[6] + 2, y + 2)
  doc.text(fmtMoney(totalScheduled - totalCompleted), cols[8] - 2, y + 2, { align: 'right' })
  doc.text(fmtMoney(retainageTotal), cols[8] + 24, y + 2, { align: 'right' })

  addFooter(doc, 'Riverbend Contracting Co. | 11260 Dunham Road | Hartland, MI 48353 | 8109236229')

  return doc
}
